export const mapColors = [
  "bg-[#FF0000]",
  "bg-[#FF3333]",
  "bg-[#FF6666]",
  "bg-[#FF9999]",
  "bg-[#93EB93]",
  "bg-[#62E062]",
  "bg-[#31D631]",
  "bg-[#00CC00]",
  "bg-[#3399FF]",
  "bg-[#5CADFF]",
  "bg-[#85C2FF]",
  "bg-[#ADD6FF]",
]

const yearFunction = () => {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: 12 }, (_, i) => currentYear - (11 - i) * 10)
}

export const mapYears = yearFunction()
